import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

Vue.prototype._mathRandom1000 = function () {
  return (Math.random() * 1000).toFixed(0) * 1
}

// 引入和风天气图标
import 'qweather-icons/font/qweather-icons.css'

// // 引入视屏监控组件
// import EZUIKit from 'ezuikit-js';
// Vue.use(EZUIKit);

// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import tools from './utils/tool.js'
Vue.use(tools)

//引入echart
//4.x 引用方式
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;



// 全局注册
Vue.component('icon', Icon);
// Vue.use(dataV);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
